import { BUCKET_PREFIX, ENVIRONMENT } from '../../utils/environment';
import type { AnimationConfig } from '../animation/settings/config';
import { AnimationKeys } from '../animation/settings/config';

const COIN_BACK_ANIMATION_SIZE = {
  width: 400,
  height: 866,
};

const COIN_BACK_ANIMATION_SIZE_BOOSTER = {
  width: 500,
  height: 866,
};

export const animationConfigs: AnimationConfig = {
  [AnimationKeys.SAFE_OPEN]: {
    maxFrames: 134,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-open/Vault_Open_v2_Collect_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 1,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
  [AnimationKeys.SAFE_CLOSE]: {
    maxFrames: 30,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-close-claim-v2/Vault_Open_v2_Collect_MONEY_2__`,
    imageExt: 'png',
    digits: 5,
    startFrame: 2,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
  [AnimationKeys.SAFE_LOCKED]: {
    maxFrames: 45,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-lock/Vault_v2_LOCKED_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 1,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
  [AnimationKeys.SAFE_OPEN_KEEP]: {
    maxFrames: 161,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-open-keep/Vault_Open_v2_KEEP_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 110,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
  [AnimationKeys.SAFE_OPEN_CLAIM]: {
    maxFrames: 224,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-open-claim/Vault_Open_v2_Collect_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 135,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
  [AnimationKeys.SAFE_CLOSE_CLAIM]: {
    maxFrames: 219,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/safe-close-claim-v2/Vault_Open_v2_Collect_MONEY_2__`,
    imageExt: 'png',
    digits: 5,
    startFrame: 30,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE,
  },
};

export const coinbackBoosterAnimationConfigs: AnimationConfig = {
  [AnimationKeys.SAFE_OPEN]: {
    maxFrames: 134,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-open/Vault_Open_CLAIM_Booster_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 1,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
  [AnimationKeys.SAFE_CLOSE]: {
    maxFrames: 70,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-close-claim-v4/Vault_Open_v4_Collect___`,
    imageExt: 'png',
    digits: 5,
    startFrame: 1,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
  [AnimationKeys.SAFE_LOCKED]: {
    maxFrames: 50,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-lock/Vault_v2_LOCKED_Booster__`,
    imageExt: 'png',
    digits: 5,
    startFrame: 1,
    loadingTimeoutMs: 3000,
    showLoading: true,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
  [AnimationKeys.SAFE_OPEN_KEEP]: {
    maxFrames: 163,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-open-keep/Vault_Open_KEEP_Booster_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 100,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
  [AnimationKeys.SAFE_OPEN_CLAIM]: {
    maxFrames: 217,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-open-claim/Vault_Open_CLAIM_Booster_`,
    imageExt: 'png',
    digits: 5,
    startFrame: 133,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
  [AnimationKeys.SAFE_CLOSE_CLAIM]: {
    maxFrames: 251,
    imagePath: `${BUCKET_PREFIX}${ENVIRONMENT}/coinback-seq/booster/safe-close-claim-v4/Vault_Open_v4_Collect___`,
    imageExt: 'png',
    digits: 5,
    startFrame: 70,
    loadingTimeoutMs: 3000,
    animationSize: COIN_BACK_ANIMATION_SIZE_BOOSTER,
  },
};
